import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  settingsList: [],
  account:null,
  settings: null,
  error: false,
  errorStatus: null,
  success:false,
  loading: false,
  loaded:false,
  customerInfo:null,
  realSettings:null,
  firmwareUpdate:null,
  firmwareUpdateError: false,
  firmwareUpdateSuccess:false,
  firmwareUpdateLoading: false,
  firmwareUpdateLoaded:false,
  firmwareDisplayUpdateSpinner : false,
  routerMac:null,
  showTimeRemaining:false,
  waitingForWan: false,
  versions:null,
  optimizeRouterDisplayUpdateSpinner: false,
  serviceRestoreSuccess:false,
};
const resetSettingsState = (state, action) => {
  return updateObject(state, initialState)
}
const initSettingsStart = (state, action) => {
  return updateObject(state, {
    error: null,
    errorStatus: null,
    loading: true,
    loaded:false
  });
};

const setSettings = (state, action) => {
  return updateObject(state, {
    account: action.fake[0],
    realSettings: action.realSettings,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchSettingsFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const changeSettingsFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true,
    errorStatus: action.errorStatus
  });
};

const serviceRestoreSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    serviceRestoreSuccess: true,
    errorStatus: null,
  });
};
const changeSettingsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true,
    errorStatus: null,
  });
};
const resetSettingsErrorSuccess = (state, action) => {
  return updateObject(state, {
    success:false,
    serviceRestoreSuccess: false,
    error:false,
  })
}

const getFirmwareUpdateStart = (state, action) => {
  return updateObject(state, {
    firmwareUpdateError: null,
    firmwareUpdateLoading: true,
    firmwareUpdateLoaded:false
  });
};

const setFirmwareUpdate = (state, action) => {

  return updateObject(state, {
    firmwareUpdate: action.firmwareUpdate,

    firmwareUpdateLoading: false,
    firmwareUpdateLoaded: true
  });
};
const setWINVersion = (state, action) => {
  return updateObject(state, {
    versions:action.versions
  })
}

const setFirmwareSpinnerUpdate = (state, action) => {
  return updateObject(state, {
    firmwareDisplayUpdateSpinner : action.firmwareDisplayUpdateSpinner
  });
};

const getFirmwareUpdateFailed = (state, action) => {
  return updateObject(state, {
    firmwareUpdateLoaded: true,
    firmwareUpdateLoading: false,
    firmwareUpdateError: true
  });
};

const setOptimizeRouterSpinnerUpdate = (state, action) => {
  return updateObject(state, {
    optimizeRouterDisplayUpdateSpinner : action.optimizeRouterDisplayUpdateSpinner
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.INIT_SETTINGS_START:
      return initSettingsStart(state, action);
    case actionTypes.SET_SETTINGS:
      return setSettings(state, action);
    case actionTypes.FETCH_SETTINGS_FAILED:
      return fetchSettingsFailed(state, action);
    case actionTypes.CHANGE_SETTINGS_SUCCESS:
      return changeSettingsSuccess(state, action);
    case actionTypes.SERVICE_RESTORE_SUCCESS:
      return serviceRestoreSuccess(state, action);
    case actionTypes.CHANGE_SETTINGS_FAILED:
      return changeSettingsFailed(state, action);
    case actionTypes.RESET_SETTINGS_ERROR_SUCCESS:
      return resetSettingsErrorSuccess(state, action);
    case actionTypes.GET_FIRMWARE_UPDATE_START:
      return getFirmwareUpdateStart(state, action);
    case actionTypes.SET_FIRMWARE_UPDATE:
      return setFirmwareUpdate(state, action);
    case actionTypes.SET_WIN_VERSION:
      return setWINVersion(state, action);
    case actionTypes.SET_FIRMWARE_SPINNER_UPDATE:
      return setFirmwareSpinnerUpdate(state, action);
    case actionTypes.GET_FIRMWARE_UPDATE_FAILED:
      return getFirmwareUpdateFailed(state, action);
      case actionTypes.SET_OPTIMIZE_ROUTER_SPINNER_UPDATE:
      return setOptimizeRouterSpinnerUpdate(state, action);
    default:
      return state;
  }
};

export default reducer;
